import React from "react";

export const CartProductOptions = (options) => {
  if (!options || options.length === 0) return null;
  
  // Filter out "Default Title" options
  const filteredOptions = options.filter(option => 
    option.value && option.value.toLowerCase() !== 'default title'
  );
  
  if (filteredOptions.length === 0) return null;
  
  return (
    <>
      {filteredOptions.map((option, index) => (
        <p key={index}>
          {option.name}: {option.value}
        </p>
      ))}
    </>
  );
};
